import React, { useState, useEffect } from "react";
import { NonIdealState, Intent, Button } from "@blueprintjs/core";
import FadeIn from "react-fade-in";

const CreatePanelLinkedSessionTable = ({ linkedSession, onOpenDialog }) => {
  const [stateLinkedSession, setLinkedSession] = useState(linkedSession);

  let displayLinkedSession = linkedSession || stateLinkedSession;

  if (
    displayLinkedSession &&
    !displayLinkedSession.startsWith("http://") &&
    !displayLinkedSession.startsWith("https://")
  ) {
    displayLinkedSession = "http://" + displayLinkedSession;
  }

  useEffect(() => {
    setLinkedSession(linkedSession);
  }, [linkedSession]);

  if (displayLinkedSession) {
    return (
      <FadeIn key={displayLinkedSession}>
        <div>
          <NonIdealState
            icon="link"
            title="You have linked the following session"
            description={
              <div>
                <a href={displayLinkedSession}>{displayLinkedSession}</a>
              </div>
            }
            action={
              <Button
                intent={Intent.PRIMARY}
                rightIcon="add"
                text="Change the Linked Session"
                onClick={onOpenDialog}
              />
            }
          />
        </div>
      </FadeIn>
    );
  } else {
    return (
      <FadeIn>
        <div>
          <NonIdealState
            icon="link"
            title="No Session Linked Yet"
            description="You did not link any session yet"
            action={
              <Button
                intent={Intent.PRIMARY}
                rightIcon="add"
                text="Add a Linked Session"
                onClick={onOpenDialog}
              />
            }
          />
        </div>
      </FadeIn>
    );
  }
};

export default CreatePanelLinkedSessionTable;
